import React, { useState } from 'react';
import type { Organization } from '@/api/services/organizations';

type Props = {
  organization: Organization;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
};

export default function EditOrganizationModal({ organization, onClose, onSave }: Props) {
  const [name, setName] = useState(organization.name);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function handleSave(event: React.FormEvent) {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setError('');
    try {
      await onSave(trimmed);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Save failed');
      setSubmitting(false);
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose} role="presentation">
      <div className="modal card card-elevated" onClick={(e) => e.stopPropagation()} role="dialog">
        <h2>Edit organization</h2>
        <form onSubmit={handleSave}>
          <label htmlFor="edit-org-name">Organization name</label>
          <input
            id="edit-org-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          {error ? <div className="alert alert-error">{error}</div> : null}
          <div className="modal-actions">
            <button type="button" className="btn" onClick={onClose} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={submitting || !name.trim()}>
              {submitting ? 'Saving…' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
